const EnumTipoLocalizacao = {
  ADDRESS: 'address',
  GEOLOCATION: 'geolocation'
}

const EnumGeolocationPermissionState = {
  PROMPT: 'prompt',
  GRANTED: 'granted',
  DENIED: 'denied'
}

const EnumFiltros = {
  ORDER_ALFA: 'orderAlfa',
  ORDER_DIST: 'orderDist'
}

export {
  EnumTipoLocalizacao,
  EnumGeolocationPermissionState,
  EnumFiltros
}
